import { Controller } from "@hotwired/stimulus"
import sortable from "html5sortable/dist/html5sortable.es"

// Connects to data-controller="settings-order"
export default class extends Controller {
  static values = {
    name: String,
    url: String,
  }

  connect() {
    sortable(this.element)
    this.handleSortUpdate = (e) => {
      let elements = e.detail.destination.items
      let settings = []
      elements.forEach((item, i) => {
        settings[i] = item.dataset.id
      })

      fetch(this.urlValue, {
        method: "POST",
        body: JSON.stringify({
          type: this.nameValue,
          elements: settings,
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.head.querySelector(`meta[name="csrf-token"]`).getAttribute("content"),
        },
      })
    }
    this.element.addEventListener("sortupdate", this.handleSortUpdate)
  }

  disconnect() {
    this.element.removeEventListener("sortupdate", this.handleSortUpdate)
    sortable(this.element, "destroy")
  }
}
